export const NODE_ACTION_TYPES = {
  SET_NODE_TYPE: 'node/SET_NODE_TYPE',
  SET_IS_NODE_DROPDOWN_OPEN: 'node/SET_IS_NODE_DROPDOWN_OPEN',
};

export const NODE_TYPES = {
  START: 'Start',
  END: 'End',
  NORMAL: 'Normal',
  WALL: 'Wall',
  WEIGHTED: 'Weighted',
  VISITED: 'Visited',
  SHORTEST: 'Shortest',
  VISITED_WEIGHTED: 'Visited_Weighted',
  SHORTEST_WEIGHTED: 'Shortest_Weighted',
};
